import type { Security } from "~types/types";

const noTransform = (v: unknown) => v;
const numberTwoDecimals = (n: number) => Number(n.toFixed(2));

type MappedField = {
    field?: string;
    transform: typeof noTransform | typeof numberTwoDecimals;
};

const FIELD_FORMATTERS: { [key: string]: MappedField } = {
    percentChange1Day: { transform: noTransform },
    price: { transform: numberTwoDecimals },
};

export function formatRealTimeData(rawData: Security): Security {
    return Object.entries(rawData).reduce((acc, [key, value]) => {
        if (key in FIELD_FORMATTERS) {
            const { transform } = FIELD_FORMATTERS[key];

            return {
                ...acc,
                [key]: transform(value),
            };
        }

        return acc;
    }, {} as Security);
}
